<template>
  <div>
    <!-- 考场状态弹窗 -->
    <div class="to_view">
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisibleObj.centerDialogVisible"
        :close-on-click-modal="false"
      >
        <div class="mian">
          <p>
            {{ $parent.stateFan == 0 ? "考试" : "练习" }}名称：{{
              statePopupstatus.ExamName
            }}
          </p>
          <p>
            总分：<span>{{ statePopupstatus.TotalScore }}</span> 分
          </p>
          <p>
            及格线：<span>{{ statePopupstatus.PassScore }}</span> 分
          </p>
          <p>
            时间：<span>{{ statePopupstatus.SpendTime }}</span> 分钟
          </p>
          <p>
            参与人数：<span>{{ statePopupstatus.StudentCount }}</span> 人
          </p>
          <p class="attention" v-if="statePopupstatus.IsLock == '考场开启'">
            注：{{
              $parent.stateFan == 0 ? "考试" : "练习"
            }}正在进行中，若结束考试，未进入
            {{ $parent.stateFan == 0 ? "考试" : "练习" }}的考生则不
            得进入，正在答题的考生将不受影响，确定结束该{{
              $parent.stateFan == 0 ? "考试" : "练习"
            }}？
          </p>
          <p
            class="attention"
            v-else-if="statePopupstatus.IsLock == '考场关闭'"
          >
            注：该{{ $parent.stateFan == 0 ? "考试" : "练习" }}尚未开始，结束
            {{ $parent.stateFan == 0 ? "考试" : "练习" }}后到达
            {{ $parent.stateFan == 0 ? "考试" : "练习" }}时间若未及时开启
            {{ $parent.stateFan == 0 ? "考试" : "练习" }}，考生将无法正常
            {{ $parent.stateFan == 0 ? "考试" : "练习" }}，您确定要关闭吗？
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleObj.centerDialogVisible = false"
            >取 消</el-button
          >
          <el-button type="primary" :loading="sundflag" @click="changetesttype"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 考试结束删除状态弹窗 -->
    <div class="delete_view">
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisibleObj.deleteVisible"
        :close-on-click-modal="false"
      >
        <span slot="footer" class="dialog-footer">
          <div class="delete_mian" v-if="$parent.stateFan == 0">
            <i class="iconfont icon-tishi1"></i>
            <p v-if="statePopupstatus.IsLock == '考场关闭'">
              该考试已关闭，删除该考试将一并删除所有考生成绩信
              息，您确定要删除“{{ statePopupstatus.ExamName }}”考试吗？
            </p>
            <p v-else-if="statePopupstatus.IsPublish == '待考试'">
              该考试还未进行，您确定要删除“{{
                statePopupstatus.ExamName
              }}”考试吗？
            </p>
            <p v-else-if="statePopupstatus.IsPublish == '考试中'">
              该考试正在进行中，删除考试，当前参与考试的考生将
              无法继续答题，且该考试的所有的考生做题数据也一并
              删除，您确定要删除“{{ statePopupstatus.ExamName }}”考试吗？
            </p>
            <p v-else-if="statePopupstatus.IsPublish == '考试结束'">
              该考试已结束，删除该考试将一并删除所有考生成绩信息，您确定要删除“{{
                statePopupstatus.ExamName
              }}”考试吗？
            </p>
          </div>
          <!-- 这是练习 -->
          <div class="delete_mian" v-if="$parent.stateFan == 1">
            <i class="iconfont icon-tishi1"></i>
            <p v-if="statePopupstatus.IsLock == '考场关闭'">
              该练习已关闭，删除该练习将一并删除所有考生成绩信
              息，您确定要删除“{{ statePopupstatus.ExamName }}”练习吗？
            </p>
            <p v-else-if="statePopupstatus.IsPublish == '待练习'">
              该练习还未进行，您确定要删除“{{
                statePopupstatus.ExamName
              }}”练习吗？
            </p>
            <p v-else-if="statePopupstatus.IsPublish == '练习中'">
              该练习正在进行中，删除练习，当前参与练习的考生将
              无法继续答题，且该练习的所有的考生做题数据也一并
              删除，您确定要删除“{{ statePopupstatus.ExamName }}”练习吗？
            </p>
            <p v-else-if="statePopupstatus.IsPublish == '练习结束'">
              该练习已结束，删除该练习将一并删除所有考生成绩信息，您确定要删除“{{
                statePopupstatus.ExamName
              }}”练习吗？
            </p>
          </div>
          <el-button @click="dialogVisibleObj.deleteVisible = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            :loading="shake"
            @click="
              dialogVisibleObj.deleteVisible = false;
              deleteRow();
            "
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 试卷组卷删除状态弹窗 -->
    <div class="delete_view">
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisibleObj.IsdeleteVisible"
        :close-on-click-modal="false"
      >
        <span slot="footer" class="dialog-footer">
          <div class="delete_mian">
            <i class="iconfont icon-tishi1"></i>
            <p>您确定要删除“{{ statePopupstatus.ExamName }}”考试吗？</p>
          </div>
          <el-button @click="dialogVisibleObj.IsdeleteVisible = false"
            >取 消</el-button
          >
          <el-button type="primary" :loading="testShake" @click="AndeleteRow()"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 复制弹窗 -->
    <div class="copy_view">
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisibleObj.copyVisible"
        :close-on-click-modal="false"
      >
        <p>
          是否确认复制 "{{ statePopupstatus.ExamName }}"
          {{ $parent.stateFan == 0 ? "考试" : "练习" }}吗？
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleObj.copyVisible = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            :loading="copySundflag"
            @click="
              dialogVisibleObj.copyVisible = false;
              copyExam();
            "
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 随机命题的复制弹窗 -->
    <div class="random_copy">
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisibleObj.randomCopy"
        :close-on-click-modal="false"
      >
        <div class="mian">
          <div class="mian_top">
            <h3>复制试卷</h3>
            <p>
              完全复制试卷内容和参加{{
                $parent.stateFan == 0 ? "考试" : "练习"
              }}的考生
            </p>
          </div>
          <div class="mian_top">
            <h3>复制范围</h3>
            <p>复制考试范围和考生,重新抽提组卷</p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            :loading="copySundflag"
            @click="
              dialogVisibleObj.randomCopy = false;
              copyExam();
            "
            >复制试卷</el-button
          >
          <el-button
            type="primary"
            :loading="copyScope"
            @click="
              dialogVisibleObj.randomCopy = false;
              randomCopy();
            "
            >复制范围</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 考试中设置的拦截弹窗 -->
    <div class="editor_view">
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisibleObj.editorIntercept"
        :close-on-click-modal="false"
      >
        <div class="mian_editor" v-if="fang">
          <p>
            {{ $parent.stateFan == 0 ? "考试" : "练习" }} &emsp;"<span>{{
              statePopupstatus.ExamName
            }}</span
            >(总分：<span>{{ statePopupstatus.TotalScore }}</span> 分时间：<span
              >{{ statePopupstatus.SpendTime }}</span
            >分钟 参考人员：<span>{{ statePopupstatus.StudentCount }}</span
            >人 及格线： <span>{{ statePopupstatus.PassScore }}</span> 分)"
            正在{{ $parent.stateFan == 0 ? "考试" : "练习" }}中,无法设置{{
              $parent.stateFan == 0 ? "考试" : "练习"
            }}信息。如需设置先结束{{
              $parent.stateFan == 0 ? "考试" : "练习"
            }}。
          </p>
        </div>
        <div class="mian_editor" v-else>
          <p>
            已有考生进入{{
              $parent.stateFan == 0 ? "考试" : "练习"
            }}，试卷将不得修改。
          </p>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleObj.editorIntercept = false"
            >确认</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  examDelete,
  examManager,
  getTestStyle,
  ManagerunLock,
  copy,
  randomCopy,
} from "@/api/index.js";
import loginvuex from "@/store/index";
export default {
  props: ["statePopupstatus"],
  updated() {
    this.send();
  },
  data() {
    return {
      dialogVisibleObj: {
        centerDialogVisible: false,
        deleteVisible: false,
        copyVisible: false, //复制弹窗
        randomCopy: false, // 随机命题弹窗
        editorIntercept: false, // 考试中编辑拦截弹窗
        IsdeleteVisible: false, // 试卷组卷的删除
      },
      sundflag: false, // 结束考试防抖
      shake: false, // 删除防抖
      testShake: false, // 试卷组卷删除防抖
      copySundflag: false, // 复制的防抖
      copyScope: false, // 复制范围防抖
      fang: true,
      arr: [],
    };
  },
  methods: {
    send() {
      this.$emit("gitStatus", this.dialogVisibleObj);
    },
    // 开始考试
    changeUnlock() {
      this.dialogVisibleObj.centerDialogVisible = false;
    },
    // 结束考试
    async changetesttype() {
      this.dialogVisibleObj.centerDialogVisible = false;
      let params = {
        examID: this.$parent.statePopupstatus.ExamID,
        hid: this.$parent.statePopupstatus.HospitalID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      let Data;
      if (
        this.$parent.statePopupstatus.IsLock === "考场开启" ||
        this.$parent.statePopupstatus.IsLock === "练习开启"
      ) {
        //结束考试按钮
        this.sundflag = true;
        Data = await examManager(params);
        setTimeout(() => {
          this.sundflag = false;
        }, 500);
      } else {
        //开启考试按钮
        this.sundflag = true;
        Data = await ManagerunLock(params);
        setTimeout(() => {
          this.sundflag = false;
        }, 500);
      }
      if (Data.status === 200) {
        this.$message({
          message: "更改成功",
          type: "success",
        });
      } else {
        this.$message.error("更改失败");
        this.sundflag = false;
      }
      this.$parent.getDatalist();
    },
    // 删除接口请求
    async deleteRow(row, index) {
      this.$parent.currentPage3 = this.$parent.currentPage3 - 1;
      let params = {
        examID: JSON.stringify(this.statePopupstatus.ExamID),
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: this.statePopupstatus.HospitalID,
      };
      this.shake = true;
      const Data = await examDelete(params);
      if (Data.status === 200) {
        this.$message({
          message: "删除成功",
          type: "success",
        });
        setTimeout(() => {
          this.shake = false;
        }, 500);
        if (this.$parent.statePopupstatus.PaperMode === "paper") {
          this.$parent.getlist();
        } else {
          this.$parent.getDatalist();
        }
      } else {
        this.shake = false;
        this.$message.error("已取消删除");
      }
    },
    async AndeleteRow(row, index) {
      let params = {
        examID: JSON.stringify(this.statePopupstatus.ExamID),
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: this.statePopupstatus.HospitalID,
      };
      this.testShake = true;
      const Data = await examDelete(params);
      if (Data.status === 200) {
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.dialogVisibleObj.IsdeleteVisible = false;
        setTimeout(() => {
          this.testShake = false;
        }, 500);
        this.$parent.getlist();
      } else {
        this.$message.error("已取消删除");
        this.testShake = false;
      }
    },
    // 复制
    async copyExam() {
      this.copySundflag = true;
      let params = {
        examID: this.$parent.statePopupstatus.ExamID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: this.$parent.statePopupstatus.HospitalID,
      };
      const Data = await copy(params);
      if (Data.status === 200) {
        this.$message({
          message: "复制成功",
          type: "success",
        });
        setTimeout(() => {
          this.copySundflag = false;
        }, 500);
        if (this.$parent.statePopupstatus.PaperMode === "paper") {
          this.$parent.getlist();
        } else {
          this.$parent.getDatalist();
        }
      } else {
        setTimeout(() => {
          this.copySundflag = false;
        }, 3000);
        this.$message.error("复制失败");
      }
    },
    // 随机选择复制
    async randomCopy() {
      this.copyScope = true;
      let params = {
        examMode: this.$parent.statePopupstatus.PaperMode, // 组卷类型 random_db
        examID: JSON.stringify(this.$parent.statePopupstatus.ExamID),
        examName: this.$parent.statePopupstatus.ExamName, //试卷名称
        mainPaperID: this.$parent.statePopupstatus.MainPaperID, //试卷总ID
        hid: this.$parent.statePopupstatus.HospitalID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      const Data = await randomCopy(params);
      if (Data.status == 200) {
        this.$message({
          message: "复制范围成功",
          type: "success",
        });
        setTimeout(() => {
          this.copyScope = false;
        }, 500);
        this.$parent.getDatalist();
      } else {
        setTimeout(() => {
          this.copyScope = false;
        }, 500);
        this.$message.error("复制失败");
      }
      // console.log(Data.status), "这里是我复制请求来的数据";
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.to_view {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    // padding: 20px 24px 9px 24px;
    // padding-bottom: 9px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
}
::v-deep .to_view .el-dialog {
  width: 441px;
  min-height: 415px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
    > .el-form-item {
      flex: 1;
      display: flex;
      align-content: center;
      ::v-deep .el-input {
        width: 420px;
      }
      .son_input > input {
        width: 420px;
      }
    }
  }
}
.delete_view {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    // padding: 20px 24px 9px 24px;
    // padding-bottom: 9px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: left !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .delete_mian {
    display: flex;
    padding: 20px 23px;
    box-sizing: border-box;
    i {
      display: inline-block;
      font-size: 16px !important;
      color: #ffc664;
      text-align: center;
      margin: 0 auto;
      margin-right: 10px;
      transform: translateY(4px);
    }
    p {
      text-align: left;
      font-size: 15px;
    }
  }

  .el-dialog__footer span > button {
    margin-top: 10px;
  }
}
::v-deep .delete_view .el-dialog {
  width: 441px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
    > .el-form-item {
      flex: 1;
      display: flex;
      align-content: center;
      ::v-deep .el-input {
        width: 420px;
      }
      .son_input > input {
        width: 420px;
      }
    }
  }
}
::v-deep .el-dialog__header {
  height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  span > button {
    width: 88px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    margin-top: 38px;
    margin-bottom: 14px;

    &:nth-child(2) {
      margin-left: 50px;
    }
  }
}
.mian {
  p {
    font-size: 15px;
    margin-bottom: 20px;
  }
  span {
    color: #ff0000;
    font-size: 16px;
    font-weight: bolder;
  }
}
::v-deep .el-dialog__body {
  padding: 14px 20px 0px 20px;
}
.attention {
  margin: 0 !important;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #aaaaaa;
  opacity: 1;
}
.copy_view {
  ::v-deep .el-dialog {
    width: 400px !important;
    height: 200px !important;
    border-radius: 5px 5px 0px 0px;
  }
  p {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 74px;
  }
  .dialog-footer > button {
    margin-top: 0px !important ;
  }
}
.random_copy {
  ::v-deep .el-dialog {
    width: 500px !important;
    min-height: 280px !important;
    border-radius: 5px 5px 0px 0px;
    .dialog-footer > button {
      width: 100px;
      height: 40px;
      margin-top: 0px !important ;
    }
  }
  .mian {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .mian_top {
      display: flex;
      height: 40px;
      align-items: center;
      margin-bottom: 30px;
      h3 {
        margin-right: 35px;
        font-size: 20px;
      }
      p {
        width: 240px;
        height: 40px;
        line-height: 62px;
      }
    }
  }
}
.editor_view {
  ::v-deep .el-dialog {
    width: 400px !important;
    min-height: 260px !important;
    border-radius: 5px 5px 0px 0px;
  }

  .mian_editor {
    margin-top: 30px;
    p {
      line-height: 24px;
      font-size: 16px;
    }
  }
}
</style>